<!-- <ngx-spinner bdColor="rgb(63,69,95)" size="medium" color="#0af0d5" type="ball-scale-pulse" [fullScreen]="true">
  <p style="color: white"> </p>
</ngx-spinner> -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-scale-pulse" [fullScreen]="true">
</ngx-spinner>
